import React, { useEffect, useState, lazy, Suspense } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

import Footer from "./assets/components/footer/footer.jsx";
import Ribbon from "../src/assets/components/ribbon/ribbon.jsx";
import Menu from "../src/assets/components/menu/menu";

import Home from "./assets/components/pages/home.jsx";
import Partners from "./assets/components/pages/partners.jsx";
import About from "./assets/components/pages/about.jsx";

import Promotions from "./assets/components/pages/promotions.jsx";
import NotFound from "./assets/components/pages/NotFound.jsx";
import DetailsProduct from "./assets/components/pages/detailsProduct.jsx";

import Remesas from "./assets/components/pages/Services/remesas.jsx";

import UpdateSystem from "./assets/components/pages/UpdateSystem/Update.jsx";
import EntidadesFinancieras from "../src/assets/components/footer/BuroEntidades.jsx";
import Aplicacion from "../src/assets/components/pages/Services/Aplicacion.jsx";
import Empleos from "../src/assets/components/pages/Empleos.jsx";
import FileUpdate from "../src/assets/components/pages/Services/fileUpdate.jsx";

import EventosDetalle from "../src/assets/components/Eventos/EventosDetalle.jsx";

// SplashScreen
import SplashScreen from "./assets/components/SplashScreen/SplashScreen.jsx";

// Página pesada cargada bajo demanda
const CotizadorCreditos = lazy(() =>
  import("./assets/components/pages/cotizadorCredito/cotizadorCredito.jsx")
);

// Página pesada cargada bajo demanda
const AvisoDePrivacidad = lazy(() =>
  import("./assets/components/AvisoDeprivacidad/AvisoPrivacidad.jsx")
);

// Página pesada cargada bajo demanda
const CostosComisiones = lazy(() =>
  import("./assets/components/CostosComisiones/CostosComisiones.jsx")
);

// Página pesada cargada bajo demanda
const Contact = lazy(() =>
  import("./assets/components/pages/contact.jsx")
);

// Página pesada cargada bajo demanda
const Product = lazy(() =>
  import("./assets/components/pages/Products.jsx")
);

// Página pesada cargada bajo demanda
const Services = lazy(() =>
  import("./assets/components/pages/Services/services.jsx")
);

// Página pesada cargada bajo demanda
const Cajeros = lazy(() =>
  import("./assets/components/pages/Services/cajeros.jsx")
);

// Página pesada cargada bajo demanda
const Convocatorias = lazy(() =>
  import("../src/assets/components/pages/Convocatorias/Convocatorias.jsx")
);


const Comunicados = lazy(() =>
  import("./assets/components/pages/Comunicados/Comunicados.jsx")
);

const EventosImportantes = lazy(() =>
  import("./assets/components/Eventos/EventosImportantes.jsx")
);

const Convenios = lazy(() =>
  import("./assets/components/Convenios/Convenios.jsx")
);

const Seguros = lazy(() =>
  import("./assets/components/pages/Services/seguros.jsx")
);

function App() {
  // Inicio de conf Splash screen
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const currentPath = window.location.pathname;

  if (currentPath !== "/cotizadorCreditos") {
    if (loading) {
      return <SplashScreen />;
    }
  }
  // Fin configuracion splashScreen

  return (
    <Router>
      <div className="App">
        <header className="App-header"></header>

        <Ribbon />
        <Menu />

        <Suspense fallback={<div>Cargando...</div>}>
          <Routes>
            {/* Las rutas deben ser diferentes para cada componente */}
            <Route path="/" element={<Home />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/about" element={<About />} />
            <Route path="/product" element={<Product />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/promotions" element={<Promotions />} />
            <Route path="/services" element={<Services />} />
            <Route path="/cajeros" element={<Cajeros />} />
            <Route path="/remesas" element={<Remesas />} />

            <Route
              path="/eventosImportantes"
              element={<EventosImportantes />}
            />

            <Route
              path="/CotizadorCreditos"
              element={<CotizadorCreditos />}
            />

            <Route
              path="/costosComisiones"
              element={<CostosComisiones />}
            />

            <Route path="/updateSystem" element={<UpdateSystem />} />

            <Route
              path="/avisoDePrivacidad"
              element={<AvisoDePrivacidad />}
            />

            <Route
              path="/aplicacionMovil"
              element={<Aplicacion />}
            />

            <Route path="/empleos" element={<Empleos />} />

            <Route
              path="/actualizacionExpediente"
              element={<FileUpdate />}
            />

            <Route
              path="/convocatorias"
              element={<Convocatorias />}
            />

            <Route
              path="/comunicados"
              element={<Comunicados />}
            />

            <Route
              path="/entidadesFinancieras"
              element={<EntidadesFinancieras />}
            />

            <Route
              path="/detailsProduct/:type/:id"
              element={<DetailsProduct />}
            />

            <Route
              path="/eventos/:id"
              element={<EventosDetalle />}
            />

            <Route
              path="/convenios"
              element={<Convenios />}
            />

            <Route
              path="/seguros"
              element={<Seguros />}
            />
            
            {/* Ruta para mostrar el componente NotFound */} 
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>

        <Footer />
      </div>
    </Router>
  );
}

export default App;